export const DEFAULT_TIMEOUT = 20000;
